// @flow
import type { Node } from 'react';
import React, { Component } from 'react';
import { Fill, Grid } from 'layout-core-components';
import Content from './Content';
import Sidebar from './Sidebar';

type LayoutSidebarProps = {
  showSidebar: boolean,
  sidebarPosition: 'left' | 'right',
  overlapSidebar: boolean,
  closeOnClickOutside: boolean,
  onSidebarClose?: () => void, // eslint-disable-line react/require-default-props
  sidebarRenderer: (toggleSidebar: () => void) => Node,
  contentRenderer: (toggleSidebar: () => void) => Node,
};

export type LayoutSidebarState = {
  isSidebarOpen: boolean,
};

export default class LayoutSidebar extends Component<LayoutSidebarProps, LayoutSidebarState> {
  static defaultProps = {
    showSidebar: false,
    sidebarPosition: 'left',
    overlapSidebar: false,
    closeOnClickOutside: false,
  };

  constructor(props: LayoutSidebarProps) {
    super(props);

    this.state = {
      isSidebarOpen: props.showSidebar,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: LayoutSidebarProps) {
    if (nextProps.showSidebar !== this.props.showSidebar) {
      this.setState({
        isSidebarOpen: nextProps.showSidebar,
      });
    }
  }

  onSidebarClose = () => {
    this.setState({
      isSidebarOpen: false,
    });

    if (this.props.onSidebarClose) {
      this.props.onSidebarClose();
    }
  };

  toggleSidebar = () => {
    const isSidebarOpen = !this.state.isSidebarOpen;

    this.setState({
      isSidebarOpen,
    });

    if (!isSidebarOpen && this.props.onSidebarClose) {
      this.props.onSidebarClose();
    }
  };

  render() {
    const { isSidebarOpen } = this.state;
    const {
      sidebarRenderer,
      contentRenderer,
      sidebarPosition,
      overlapSidebar,
      closeOnClickOutside,
    } = this.props;

    return (
      <Fill to="parent">
        <Grid row="repeat(3, 1fr )">
          <Sidebar
            show={isSidebarOpen}
            position={sidebarPosition}
            onClickOutside={closeOnClickOutside ? this.onSidebarClose : undefined}
          >
            <Fill to="parent">{sidebarRenderer(this.toggleSidebar)}</Fill>
          </Sidebar>
          <Content
            isSidebarOpen={isSidebarOpen}
            overlapSidebar={overlapSidebar}
            sidebarPosition={sidebarPosition}
          >
            <Fill to="parent">{contentRenderer(this.toggleSidebar)}</Fill>
          </Content>
        </Grid>
      </Fill>
    );
  }
}
